import axios from 'axios'
import config from './config'
import { store } from './store'
import { showErrorMessage, showLoader, hideLoader, logout } from './actions'

axios.defaults.baseURL = config.endpoints.API_URL

let pendingRequests = 0

const isRegisterTokenRequest = err => {
  const requestUrl = (err && err.config && err.config.url) || ''
  return /\/Notificaciones\/RegisterToken(?:\?|$)/i.test(requestUrl)
}

const setLoadingSpinner = isLoading => {
  if (isLoading) {
    pendingRequests++
    store.dispatch(showLoader())
  } else if (pendingRequests > 0) {
    pendingRequests--
    if (pendingRequests <= 0) {
      store.dispatch(hideLoader())
    }
  }
}

axios.interceptors.request.use(
  config => {
    setLoadingSpinner(true)

    config.headers = {
      accept: '*/*'
    }
    return config
  },
  err => err
)

axios.interceptors.response.use(
  res => {
    setLoadingSpinner(false)
    return res
  },
  err => {
    // NOTE: 🔥 Loader component
    setLoadingSpinner(false)

    if ((err.config && err.config.silentError) || isRegisterTokenRequest(err)) {
      return Promise.reject(err)
    }

    const {
      request: { status = 0 },
      message = ''
    } = err
    if (status === 401 || message.includes('Network Error')) {
      store.dispatch(logout())
      store.dispatch(showErrorMessage('Algo salió mal. Por favor, intentá más tarde'))
      return Promise.reject(err)
    }
    store.dispatch(
      showErrorMessage(
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Ocurrió un error'
      )
    )
    return Promise.reject(err)
  }
)

/*
 * Smart Guard
 */
export const getSpecialities = async () => {
  const url = '/check-in/Especialidades'
  return await axios.get(url)
}

export const getWaitingTimes = async speciality => {
  const url = '/check-in/TiemposEspera?especialidad=' + speciality
  return await axios.get(url)
}

export const getCheckInAppointment = async params => {
  const url = `/check-in/ObtenerTurno`
  return await axios.post(url, params)
}

export const recoverOldCheckInAppointmentData = async params => {
  const url = `/check-in/ObtenerTurnoViejo?clinica=${params.clinic}&turno=${params.appointment}`
  return await axios.get(url)
}

export const getLinePosition = async (clinic, appointment) => {
  const url = `/check-in/ObtenerPosicion?clinica=${clinic}&turno=${appointment}`
  return await axios.get(url)
}

export const cancelCheckInAppointment = async params => {
  const url = '/check-in/CancelarTurno'
  return await axios.post(url, params)
}

/*
 * Programmed Guard
 */

export const confirmProgrammedGuardAppointment = params => {
  const url = '/Guardias/Confirmar'
  return axios.post(url, params)
}

export const getProgrammedGuardAvailableAppointments = data => {
  const url = '/Guardias/TurnosDisponibles'
  return axios.get(url, { params: data })
}

export const getGolEnabledSpecs = () => {
  const url = '/Guardias/EspecialidadesGOL'
  return axios.get(url)
}

export const getCancelReasons = async clinic => {
  const url = `/turnos/MotivosBaja?clinica=${clinic}`
  return await axios.get(url)
}

export const cancelProgrammedGuardAppointment = async (appointment, clinic, reason) => {
  const url = `/turnos/Cancelar`
  const params = {
    clinica: clinic,
    nroSolicitud: appointment,
    codigoMotivo: reason
  }
  return await axios.post(url, params)
}

/*
 * Metadata
 */

export const getDocumentTypes = async () => {
  const url = '/metadatos/ObtenerValores?clave=TipoDocumento'
  return await axios.get(url)
}

export const getGenders = async () => {
  const url = '/metadatos/ObtenerValores?clave=Sexo'
  return await axios.get(url)
}

/*
 * Patient
 */

export const getHealthInsurances = async () => {
  const url = '/pacientes/ObtenerObrasSociales'
  return await axios.get(url)
}

export const getHealthInsurancePlans = async healthInsurance => {
  const url = `/pacientes/ObtenerPlanes?obraSocial=${healthInsurance}`
  return await axios.get(url)
}

export const getPatientLogin = async request => {
  const url = '/pacientes/IniciarSesion'
  return await axios.get(url, { params: request })
}

export const getPatientByClinic = async request => {
  const url = '/pacientes/ObtenerPaciente'
  return await axios.get(url, { params: request })
}

export const patientSignUp = async params => {
  const url = '/pacientes/CrearPacienteMindware'
  return await axios.post(url, params)
}

/*
 * Auditoria
 */
export const logAuditAction = async data => {
  const url = `/Auditoria/RegistrarAccion`
  return await axios.post(url, data)
}
//Notificaciones

export const createNotification = async ({
  targetClientId,
  notificationTypeCode,
  mobileTitle,
  payload: { message, url: payloadUrl, isInternal }
}) => {
  const url = '/Notificaciones/Push'
  return await axios.post(url, {
    targetClientId,
    notificationTypeCode,
    mobileTitle,
    payload: { message, url: payloadUrl, isInternal }
  })
}
